import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { CardView, Spacer } from 'design-system';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { FinancialsPeriod } from '../types';
import { abbreviateNumber, getMarginStr, getPeriodKey } from '../utils/format';
import BarInfo from './BarInfo';
import StockFinancialCardInfoBadge from './StockFinancialCardInfoBadge';
import StockFinancialCardsHeader from './StockFinancialCardsHeader';
import Timeframe from './Timeframe';
const BalanceSheet = ({ assetId, selection }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const periodKey = getPeriodKey(selection);
    const balanceSheetData = useAppSelector((state) => state.stockInfoReducer.financials?.[assetId]?.[periodKey]?.balanceSheet);
    const [state, setState] = useState([]);
    useEffect(() => {
        if (balanceSheetData?.length) {
            setSelectedIndex(0);
            setState(balanceSheetData);
        }
    }, [selection, balanceSheetData]);
    const colors = useColors();
    if (!state.length)
        return null;
    const isQuarterlySelected = selection === FinancialsPeriod.QUARTERLY && balanceSheetData;
    const data = state.map((eachBalanceSheetData) => ({
        firstBarY: eachBalanceSheetData.totalAssets,
        secondBarY: eachBalanceSheetData.totalLiabilities,
        label: isQuarterlySelected
            ? `Q${eachBalanceSheetData.fiscalQuarter} ${String(eachBalanceSheetData.fiscalYear).slice(-2)}`
            : String(eachBalanceSheetData.fiscalYear),
    }));
    return (<CardView withPadding>
      <StockFinancialCardsHeader title="Balance sheet" infoModalTitle="Balance sheet" infoModalDesc="Details a company’s assets and liabilities - what it owns, and what it owes."/>
      <Spacer h={16}/>
      <StockFinancialCardInfoBadge title="Debt to assets" info={getMarginStr(state[selectedIndex].totalAssets, state[selectedIndex].totalLiabilities)}/>
      <Spacer h={8}/>
      <Timeframe data={data} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} firstBarColor={colors.elements.brand} secondBarColor={colors.gradients.darkPink.colors[0]}/>
      <Spacer h={16}/>
      <View style={styles.barInfo}>
        <View style={styles.flex2}>
          <BarInfo title="Assets" color={colors.elements.brand} metrics={abbreviateNumber(state[selectedIndex].totalAssets)}/>
        </View>
        <View style={styles.flex3}>
          <BarInfo title="Liabilities" color={colors.gradients.darkPink.colors[0]} metrics={abbreviateNumber(state[selectedIndex].totalLiabilities)}/>
        </View>
      </View>
    </CardView>);
};
export default BalanceSheet;
const styles = StyleSheet.create({
    barInfo: {
        flexDirection: 'row',
    },
    flex2: {
        flex: 2,
    },
    flex3: {
        flex: 3,
    },
});
